import React from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/Button";
import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../components/ui/Card";

import {
  Briefcase,
  Clock,
  TrendingUp,
  Users,
  ShieldCheck,
  BadgeDollarSign,
} from "lucide-react";

export default function DevenirInterimaire() {
  const faqItems = [
    {
      question: "Comment ça va se passer après l'entretien ?",
      answer: (
        <p>
          Il suffit d'attendre que notre équipe vous contacte pour une
          proposition de mission.
        </p>
      ),
    },
    {
      question: " Combien de temps faut-il attendre pour obtenir une mission ?",
      answer: (
        <p>
          Le délai pour obtenir une mission peut varier de quelques jours à
          quelques semaines, tout dépend des besoins de nos clients
        </p>
      ),
    },

    {
      question: "C'est possible de reporter des rendez-vous ?",
      answer: (
        <p>
          Il est tout à fait possible de décaler un rendez-vous si nécessaire.
          Si vous souhaitez annuler votre rendez-vous, vous pouvez le faire par
          téléphone ou par e-mail en respectant un délai de prévenance
          raisonnable.{" "}
        </p>
      ),
    },

    {
      question: " Quelle est la durée de vos missions en général ? ",
      answer: (
        <p>
          Les missions dans notre agence peuvent varier de quelques jours à
          plusieurs mois, selon la demande et les besoins du client. Les
          missions à court terme sont plus fréquentes, mais il peut y avoir des
          opportunités pour des missions plus longues. Bon nombre de nos
          contrats se convertissent en CDI.{" "}
        </p>
      ),
    },
    {
      question:
        "On peut venir sans rendez-vous ou il faut forcément prendre rendez-vous ?",
      answer: (
        <p>
          Bien que nous acceptions les candidatures sans rendez-vous, il est
          tout de même préférable de prendre un rendez-vous auparavant.{" "}
        </p>
      ),
    },

    {
      question: "Est-ce que votre agence accepte les acomptes?",
      answer: (
        <p>
          Oui, il est possible de bénéficier d'acompte toutes les semaines (sous
          réserve que nous ayons les relevés d'heure validées par le
          client){" "}
        </p>
      ),
    },
    {
      question: "À  quelle date du mois on est payé pour une mission?",
      answer: <p>Le paiement se fait le 12 de chaque mois. </p>,
    },
    {
      question: "Quels secteurs vous proposez ?",
      answer: (
        <p>
          Il est possible de trouver des missions variées dans des domaines tels
          que l'industrie, le transport/la logistique, le BTP,
          l'hôtellerie/restauration et le secteur tertiaire. Nous intervenons
          dans plus de 44 secteurs différents.{" "}
        </p>
      ),
    },

    {
      question: "Quelle est la différence entre intérim et CDD ?",
      answer: (
        <p>
          Il n'y a aucune différence. En France, il n'existe que 2 types de
          contrat : CDI et CDD. Les contrats d'intérim (ou de mise à
          disposition) sont des CDD
        </p>
      ),
    },

    {
      question: "Est-ce que vous avez des missions de nuit ?",
      answer: (
        <p>
          Il est courant pour notre agence de proposer des missions de nuit, en
          fonction de la demande des entreprises.
        </p>
      ),
    },
  ];

  const [openIndex, setOpenIndex] = useState(false);
  const benefits = [
    {
      icon: BadgeDollarSign,
      title: "Rémunération avantageuse",
      description:
        "Bénéficiez d\'une rémunération compétitive (+10% congés payés, +10% fin de mission, etc.)",
    },
    {
      icon: Briefcase,
      title: "Missions variées",
      description:
        "Accédez à une large gamme de missions dans différents secteurs d\'activité et découvrez de nouveaux environnements de travail.",
    },
    {
      icon: Clock,
      title: "Avantages sociaux",
      description:
        "Adhérent au FASTT : Financement de projet, garde d'enfants, location d'un véhicule, etc.",
    },
    {
      icon: TrendingUp,
      title: "Développez vos compétences",
      description:
        "Enrichissez votre expérience professionnelle et découvrez un réel tremplin vers l'emploi durable.",
    },
    {
      icon: Users,
      title: "Couverture Santé",
      description:
        "Bénéficiez de la mutuelle et la prévoyance pour les intérimaires dès la première heure ou automatiquement à partir de 414h de mission.",
    },
    {
      icon: ShieldCheck,
      title: "Missions sécurisées",
      description:
        "Travaillez en toute sécurité avec des entreprises partenaires respectées et dans le respect du droit du travail.",
    },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <section className="bg-gradient-to-r from-blue-50 to-indigo-50 pt-20 pb-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Devenir intérimaire chez J'❤️ Intérim
              </h1>
              <p className="text-lg text-gray-700 text-justify">
                Rejoignez nos intérimaires et accédez à de nombreuses
                opportunités d'emploi adaptées à vos compétences et aspirations.
              </p>
            </div>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
              Pourquoi choisir J'M Intérim ?
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {benefits.map((benefit, index) => (
                <Card
                  key={index}
                  className="flex flex-col items-center text-center p-6 transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-xl hover:border-blue-500 group"
                >
                  <CardHeader className="p-0 mb-4 items-center flex flex-col">
                    <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4 transition-colors duration-300 group-hover:bg-blue-600 group-hover:text-white">
                      <benefit.icon className="h-8 w-8" />
                    </div>
                    <CardTitle className="text-xl font-semibold text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
                      {benefit.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="p-0">
                    <p className="text-gray-600 text-sm text-justify">
                      {benefit.description}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Foire aux questions
                </h2>
                <div className="space-y-4">
                  {faqItems.map((item, idx) => (
                    <div
                      key={idx}
                      className=" bg-blue-600 border border-blue-600 rounded-lg overflow-hidden "
                    >
                      <button
                        className="w-full flex justify-between items-center p-4 font-semibold bg-blue-450 hover:bg-blue-400 text-white"
                        onClick={() =>
                          setOpenIndex(openIndex === idx ? null : idx)
                        }
                      >
                        <span>{item.question}</span>
                        <svg
                          className={`transform transition-transform ${openIndex === idx ? "rotate-180" : ""}`}
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          width={20}
                          height={20}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </button>
                      {openIndex === idx && (
                        <div className="p-4 bg-white border-t border-gray-300">
                          {item.answer}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
                  Comment s'inscrire ?
                </h2>

                <div className="space-y-8">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-600 text-white text-xl font-bold rounded-full w-10 h-10 flex items-center justify-center mr-4">
                      1
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        Créez votre profil
                      </h3>
                      <p className="text-gray-600 mb-2">
                        Inscrivez-vous en ligne en remplissant notre formulaire.
                        Indiquez vos informations personnelles, votre expérience
                        et vos compétences.
                      </p>
                      <p className="text-sm text-gray-500">
                        Vous pouvez également nous envoyer directement votre CV
                        par email.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-600 text-white text-xl font-bold rounded-full w-10 h-10 flex items-center justify-center mr-4">
                      2
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        Entretien personnalisé
                      </h3>
                      <p className="text-gray-600 mb-2">
                        Un conseiller J'M Intérim vous contacte pour un
                        entretien afin de mieux connaître votre parcours, vos
                        attentes et vos disponibilités.
                      </p>
                      <p className="text-sm text-gray-500">
                        Cette étape est essentielle pour vous proposer des
                        missions adaptées à votre profil et à vos aspirations.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-600 text-white text-xl font-bold rounded-full w-10 h-10 flex items-center justify-center mr-4">
                      3
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        Constitution de votre dossier
                      </h3>
                      <p className="text-gray-600 mb-2">
                        Complétez votre dossier avec les documents nécessaires
                        (pièce d'identité, carte vitale, RIB, diplômes, etc.).
                      </p>
                      <p className="text-sm text-gray-500">
                        Notre équipe vous accompagne dans cette démarche
                        administrative pour faciliter votre prise de poste.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 bg-blue-600 text-white text-xl font-bold rounded-full w-10 h-10 flex items-center justify-center mr-4">
                      4
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        Proposition de missions
                      </h3>
                      <p className="text-gray-600 mb-2">
                        Nous vous proposons des missions correspondant à votre
                        profil, vos compétences et vos disponibilités.
                      </p>
                      <p className="text-sm text-gray-500">
                        Vous restez libre d'accepter ou de refuser les missions
                        proposées selon vos préférences.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-12 text-center">
                  <Link to="/contact">
                    <Button className="bg-blue-600 hover:bg-blue-700 text-lg px-6 py-3 text-white">
                      S'inscrire maintenant
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
                Documents nécessaires
              </h2>
              <p className="text-center text-gray-700 mb-10">
                Pour faciliter votre inscription, préparez les documents
                suivants :
              </p>

              <div className="bg-gray-50 p-8 rounded-lg shadow-sm">
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-green-500 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-gray-700">
                      Pièce d'identité en cours de validité
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-green-500 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-gray-700">
                      Carte vitale ou attestation de sécurité sociale
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-green-500 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-gray-700">
                      Relevé d'identité bancaire (RIB)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-green-500 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-gray-700">
                      CV à jour détaillant vos expériences professionnelles
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-green-500 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-gray-700">
                      Diplômes et certificats de qualification
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-green-500 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-gray-700">
                      Permis de conduire (si applicable pour les missions)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-green-500 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-gray-700">
                      Autres certificats spécifiques (CACES, habilitations
                      électriques, etc.)
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-blue-600">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              Prêt à rejoindre J'M Intérim ?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Inscrivez-vous dès aujourd'hui et découvrez nos opportunités
              d'emploi
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/contact">
                <Button className="bg-white text-blue-600 hover:bg-blue-50 text-lg px-6 py-3">
                  S'inscrire
                </Button>
              </Link>
              <Link to="/offres-emploi">
                <Button
                  variant="outline"
                  className="border-white text-white hover:bg-blue-700 text-lg px-6 py-3"
                >
                  Voir les offres d'emploi
                </Button>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
